<template>
  <form @input="$emit('input', formattedLetterWords)">
    <input type="text" v-model="letterWords" placeholder="Words" />
  </form>
</template>

<script>
// "letterWords": ["hello", "hi", "bye"]

export default {
  name: 'Type3b',
  data() {
    return {
      letterWords: '',
    };
  },
  computed: {
    formattedLetterWords() {
      let result = JSON.parse(JSON.stringify(this.letterWords))
      .replace(/\s/g, '').replace(/[\,\/]/gi, ',').split(',')
      return result;
    },
  },
};
</script>
